import { Controller } from "@hotwired/stimulus"
import { placeField } from "../lib/custom_fields"

// The holder of a record type's own fields on a form (Studio step 3,
// 2026-10-19). On connect each field moves to where its anchor says; a field
// the chat adds live arrives through the custom-fields:added event. The form
// is the closest <form>, or the box marked data-custom-fields-root (the
// action item form has no <form> tag).
export default class extends Controller {
  static targets = ["holder"]

  connect() {
    this._root = this.element.closest("form, [data-custom-fields-root]") || this.element.parentElement
    ;[...this.element.querySelectorAll(":scope > [data-custom-field]")].forEach((el) => this.place(el))
    this._onAdded = (e) => this.place(e.detail?.el || e.target)
    window.addEventListener("custom-fields:added", this._onAdded)
  }

  disconnect() { window.removeEventListener("custom-fields:added", this._onAdded) }

  place(el) {
    if (!el || !el.matches?.("[data-custom-field]")) return
    let anchor = {}
    try { anchor = JSON.parse(el.dataset.customFieldAnchor || "{}") } catch (e) { anchor = {} }
    placeField(el, anchor, { root: this._root, holder: this.element })
  }
}
